(() => {
  const trigger = document.getElementById('tsv-a11y-trigger');
  if (!trigger) return;

  const selectors = [
    '#accessiblyAppDialogButton',
    '#accessiblyAppWidgetButton',
    'button.accessibly-app-widget-button',
    'button[id^="accessiblyApp"]',
    'button[class*="accessibly-app-widget-button"]'
  ];

  const findWidgetBtn = () => document.querySelector(selectors.join(','));

  function tryOpenWidget() {
    const btn = findWidgetBtn();
    if (!btn) return false;
    try {
      btn.click();
    } catch (e) {}
    return true;
  }

  trigger.addEventListener('click', (e) => {
    e.preventDefault();
    e.stopPropagation();

    if (tryOpenWidget()) return;

    const mo = new MutationObserver((mut, obs) => {
      if (tryOpenWidget()) { obs.disconnect(); clearInterval(iv); }
    });

    mo.observe(document.documentElement, {
      childList: true,
      subtree: true
    });

    let tries = 20;
    const iv = setInterval(() => {
      if (tryOpenWidget() || --tries <= 0) {
        clearInterval(iv);
        mo.disconnect();
      }
    }, 250);
  });
})();